import Impacts from "./Impacts";

export default Impacts;